module.exports = __webpack_public_path__ + "static/Bigger-Trees_feature-f9cd63444da8440aed764e26ee71286d.webp";